import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { SRow, SCol } from '@avalara/skylab-sdk/react';
import PaymentMethodSelector from './payment-method-selector';
import { selectDefaultPaymentMethod, selectPaymentMethodSelectionInfo } from '../../../selectors/account';
import { setSelectedPaymentMethod } from '../../../store/account';
import { selectState } from '../../../selectors';
const PaymentSelection = () => {
    const { account } = useSelector(selectState);
    const dispatch = useDispatch();
    const { paymentMethods, selectedPaymentMethod } = account;
    const defaultPaymentMethod = useSelector(selectDefaultPaymentMethod);
    const initPaymentMethod = defaultPaymentMethod != null ? defaultPaymentMethod : paymentMethods[0];
    const paymentMethodSelectionInfo = useSelector(selectPaymentMethodSelectionInfo);
    const onSetPaymentMethod = (paymentMethodId) => dispatch(setSelectedPaymentMethod(paymentMethodId));
    const setDefaultPaymentMethod = initPaymentMethod != null
        ? () => dispatch(setSelectedPaymentMethod(initPaymentMethod.Id))
        : undefined;
    return (selectedPaymentMethod === null
        ? React.createElement("button", { "data-ref": 'buy.payment-selection.submit-button', className: 'link margin-left-md', onClick: setDefaultPaymentMethod }, "Use existing payment method")
        : React.createElement(SRow, null,
            React.createElement(SCol, { span: 'lg-8 md-12 6' },
                React.createElement(PaymentMethodSelector, { paymentMethodSelectionInfo: paymentMethodSelectionInfo, onSetPaymentMethod: onSetPaymentMethod }))));
};
export default PaymentSelection;
